import EstimationStatus from './EstimationStatus';

export default (currentValue: number, savedValue: number, placedValue: number): EstimationStatus => {
    if (currentValue !== 0 && currentValue === placedValue) {
        return EstimationStatus.Placed;
    } else if (currentValue !== 0 && currentValue === savedValue) {
        return EstimationStatus.Draft;
    }
    if (currentValue === 0) {
        return EstimationStatus.Null;
    }
    return EstimationStatus.New;
};



// WEBPACK FOOTER //
// ./src/domain/estimations/getEstimationStatus.ts